import toast from "react-hot-toast";

const errorHandler = (error) => {
    if (Array.isArray(error?.messages) || typeof error?.messages === "object") {
        const errorMessages = Object.keys(error?.messages)
            .map((item) => error?.messages[item].toString().replace(".", "\n"))
        toast.error(errorMessages, { position: "top-center" });
    } else {
        toast.error(error?.message, { position: "top-center" });
        return false;
    }
};

export default errorHandler;